import {FC} from 'react'
import {Input} from '../Input/Input'

type tableHeaderProps = {
  headers: {
    key: string
    value: string
    type: string
    badge?: any
    disable?: boolean
    action?: (param: any) => void
    size?: string
    show?: boolean
    noLimit?: boolean
    noOrder?: boolean
    products?: any
  }[]
  sortTable: (type: 'ASC' | 'DESC', key: string, param: any) => void
  stateSort: {
    field: string
    type: 'ASC' | 'DESC'
  }
  copyData: any[]
  selectAllChecked?: boolean
  onSelectAll?: (checked: boolean) => void
}

const TableHeader: FC<tableHeaderProps> = ({
  headers,
  sortTable,
  stateSort,
  copyData,
  selectAllChecked,
  onSelectAll,
}) => {
  return (
    <>
      <thead className='d-flex w-100'>
        <tr className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted'>
          {headers.map((header) => (
            <th
              /* eslint-disable eqeqeq */
              style={{
                minWidth: header.size == 'sm' ? '' : '10em',
                width: header.size == 'sm' ? '100px' : '',
              }}
              className={`${
                header.size == 'sm' ? '' : 'w-25'
              } mx-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center ${
                header.hasOwnProperty('show') ? (header.show ? '' : 'd-none') : ''
              }`}
              key={header.value}
              onClick={async () => {
                if (header.key && !header.noOrder && header.type !== 'checkBox') {
                  await sortTable(
                    stateSort.type === 'DESC' ? 'ASC' : 'DESC',
                    header.value,
                    header.type == 'datetime' ? 'datetime' : typeof copyData[0][header.value]
                  )
                }
              }}
              /* eslint-enable eqeqeq */
            >
              {header.type === 'checkBox' ? (
                <div style={{paddingLeft: '6.5px'}}>
                  <Input
                    inputAttr={{type: 'checkbox'}}
                    checked={!!selectAllChecked}
                    change={(checked: boolean) => onSelectAll?.(checked)}
                    size='small'
                  />
                </div>
              ) : (
                header.key &&
                !header.noOrder && <i style={{marginRight: '.4em'}} className='fas fa-sort'></i>
              )}
              {/* Só exibe o texto do header se não for checkBox */}
              {header.type !== 'checkBox' && header.key}
            </th>
          ))}
        </tr>
      </thead>
    </>
  )
}

export {TableHeader}
